import { map } from '../../../lib/utilities';
import API from '../../API/api';

/**
 * ----------------------------------------------------------------------------
 *
 *             This is really quick'n'dirty af
 *             as the checkout will get an overhaul anyways
 *
 * ----------------------------------------------------------------------------
 */

let loading = false;
const endpoints = [
    '/address/id/provinces',
    '/address/id/cities',
    '/address/id/areas',
    '/address/id/postcodes',
];
const selects = [];
const values = [
    { name: 'province', value: '' },
    { name: 'city',     value: '' },
    { name: 'area',     value: '' },
    { name: 'postcode', value: '' },
];


export function handleTreeStructure(
    selectorState,
    selectorCity,
    selectorArea,
    selectorPostcode
) {
    selects.push(
        $(selectorState),
        $(selectorCity),
        $(selectorArea),
        $(selectorPostcode)
    );

    selects.forEach((select, index) => {
        fetchIntitialValue(select, index);

        $(select).on('change', (event) => {
            setValue(index, $(event.target).val());

            const followingSelects = selects.slice(index + 1);
            emptySelects(followingSelects);
            disableSelects(followingSelects);

            if (index !== selects.length - 1) {
                loadNextOptions(index + 1);
            }
        });
    });

    disableSelects(selects.slice(getFirstSelectIndexWithoutValue() + 1));
}

const fetchIntitialValue = (select, index) =>
    (values[index].value = $(select).val());

const getFirstSelectIndexWithoutValue = () => {
    const index = values.findIndex((valueContainer) => valueContainer.value === '');
    return index > -1
        ? index
        : values.length;
};

const emptySelects = (selects) =>
    selects.forEach(select => $('option:not(:first-child)', select).remove());

const disableSelects = (selects) =>
    selects.forEach(select => $(select).attr('disabled', 'disabled'));

const enableSelect = index => console.log(index) ^
    $(selects[index]).removeAttr('disabled');

const setValue = (index, value) =>
    (values[index] = { ...values[index], value });

const loadNextOptions = (index) => {
    loading = true;

    API
        .GET({
            apiPath: getEndpoint(index),
            data: values.slice(0, index).reduce((acc, { name, value }) => ((acc[name] = value) && acc), {}),
            dataType: 'json',
        })
        .then(createAndInsertOptions(index))
        .then(enableSelect);
};

//TODO: verify implementation
const createAndInsertOptions = index => options => {
    const $options = map(options, ([value, label]) => $(`<option value="${value}">${label}</option>`));
    $('option', selects[index]).remove();
    selects[index].append($options);
    return index;
};

const getEndpoint = index =>
    endpoints[index];
